<template>
    <template v-if="this.message">
       <div v-html="this.message"></div>
    </template>
    <div class="text-center loading-spinner">
        <template v-if="this.showLcLogo">
            <img :alt="this.companyName + ' logo'" class="my-5" :src="this.companyLogoPath" style="max-width:100px; height:auto;" :title="this.companyName + ' logo'"/>
        </template>
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <!-- TODO -- get the actual affiliate name/logo as we do for Lumen  -->
<!--        <div class="mt-5" v-if="this.showAffiliateLogo">-->
<!--            <small>In partnership with</small><br>-->
<!--            <img alt="Logo" class="my-4" src="/images/prets-quebec-logo.jpg" style="max-width:100px; height:auto;" title="Logo"/>-->
<!--        </div>-->
    </div>
</template>

<script>

export default {
    name: 'LoadingAnimation',
    components: {
    },
    props: {
        showLcLogo: {
            type: Boolean,
            required: false,
            default: true,
        },
        showAffiliateLogo: {
            type: Boolean,
            required: false,
            default: false,
        },
        brandLogo: {
            type: Array,
            required: false,
            default: null,
        },
        message: {
            type: String,
            required: false,
            default: null,
        }
    },
    data: () => {
        const testData = true;

        return {
            testData,
        };
    },
    methods: {
    },
    computed: {
        companyName() {
            return this.brandLogo?.name ?? 'CompareHub';
        },
        companyLogoPath() {
            return this.brandLogo?.logo_path ?? '/assets/images/compare-hub-logo.png';
        },
    },
    created() {
        // console.log('Component created');
    },
    mounted() {
        // console.log('Component mounted');
    },
    watch: {
    }
};
</script>
